module.exports = __webpack_public_path__ + "media/icons/half-star-161288c2.svg";